import { render, staticRenderFns } from "./base-column-state.vue?vue&type=template&id=dffd4066&scoped=true&"
import script from "./base-column-state.vue?vue&type=script&lang=js&"
export * from "./base-column-state.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffd4066",
  null
  
)

export default component.exports